import React from "react";
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import clsx from 'clsx';
import { green } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  }
}))

const LoadingButton = (props) => {
  let { isLoading, color, children, ...rest} = props
  if (isLoading) {
    return <Button color={color} startIcon={<CircularProgress color={color} size={20} />} {...rest} disabled>{children}</Button>    
  }
  return <Button color={color} {...rest}>{children}</Button>
}

export const LoadingSuccessButton = (props) => {
  const classes = useStyles()
  const { className, isLoading = false, success = false, children, ...rest} = props
  const buttonClassname = clsx(className, {
    [classes.buttonSuccess]: success,
  });
  return <div className={classes.wrapper}>
    <Button {...rest}
      variant="contained"
      color="primary"
      className={buttonClassname}
      disabled={isLoading}
      >{children}</Button>
      {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
  </div>
}

export default LoadingButton;